<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<roma-modal-template
  [showHeader]="false"
  [contentMinHeight]="false"
  [isLoading]="isLoading"
  size="md"
  [disableSuccess]="flightRequest"
  (success)="submit()"
  (cancel)="cancelEvt()"
>
  <div class="row">
    <div class="col-12">
      <h2 class="modal-title">
        {{
          title
            ? action === 'ADD'
              ? ('customProperties.addTitle'
                | translate: { type: '"' + title + '"' })
              : ('customProperties.editTitle'
                | translate: { type: '"' + title + '"' })
            : action === 'ADD'
            ? ('customProperties.addTitleShort' | translate)
            : ('customProperties.editTitleShort' | translate)
        }}
      </h2>
      <form [formGroup]="form" id="myform" #myForm>
        <div class="row">
          <div class="mbottom-field col-12 col-md-6">
            <div>
              <label for="name" class="name-label">
                {{ 'customProperties.name' | translate }}
              </label>
              <input
                id="name"
                class="form-control"
                aria-describedby="emailHelp"
                formControlName="name"
                [maxLength]="options.nameMaxLength"
                type="text"
                [placeholder]="'add-categories-common.placeholder' | translate"
                [ngClass]="{
                  'is-invalid':
                    fieldName?.displayError ||
                    fieldNameEl?.displayError ||
                    false
                }"
              />

              <roma-field-error-display
                #fieldName
                fieldName="name"
                errorMsg="general.requiredField"
                [form]="form"
              >
              </roma-field-error-display>
              <roma-field-error-display
                #fieldNameEl
                fieldName="name"
                errorMsg="customProperties.customFieldName"
                [errorName]="'containBlockedCharacters'"
                [form]="form"
              >
              </roma-field-error-display>
            </div>
          </div>
          <div class="mbottom-field col-12 col-md-6">
            <div>
              <div class="field-type">
                <label for="exampleInputEmail1" class="name-label">
                  {{ 'customProperties.fieldType' | translate }}
                </label>
                <ng-select
                  id="type"
                  bindLabel="label"
                  bindValue="value"
                  [items]="typeItems"
                  [ngClass]="{ 'is-invalid': fieldType?.displayError || false }"
                  (change)="changeType($event)"
                  formControlName="type"
                  [placeholder]="'customProperties.selectType' | translate"
                  [notFoundText]="
                    'hiring.form.placeholder_notfound' | translate
                  "
                  [disabled]="form.get('type').status === 'DISABLED'"
                  [ngClass]="{
                    'is-disable': form.get('type').status === 'DISABLED'
                  }"
                  style="margin-bottom: 0 !important"
                >
                </ng-select>

                <roma-field-error-display
                  #fieldType
                  fieldName="type"
                  errorMsg="general.requiredField"
                  [form]="form"
                >
                </roma-field-error-display>
              </div>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="form.get('type').value === dynamicPropertyTypeRef.Select"
        >
          <div class="options-header">
            <div class="field-options">
              {{ 'filter.options' | translate }}
            </div>
            <div class="add-field" (click)="addOption()">
              {{ 'customProperties.addTemplate.title' | translate }}
              <span>
                <a class="btn-add">
                  <img src="assets/icons/gl_plus-circle.svg" />
                </a>
              </span>
            </div>
          </div>
          <ng-container
            formArrayName="options"
            *ngFor="let option of optionsControl.controls; let i = index"
            #containerRow
            id="containerRow"
          >
            <ng-container [formGroupName]="i">
              <div class="option-input">
                <input
                  id="name"
                  type="text"
                  id="inputTest"
                  #inputTest
                  class="form-control option"
                  [formControlName]="i"
                  [maxLength]="options.nameMaxLength"
                  [placeholder]="
                    'customProperties.formOptionPlaceholder' | translate
                  "
                  [ngClass]="{
                    'is-invalid':
                      !option?.valid &&
                      option?.touched &&
                      option?.dirty &&
                      option.status === 'INVALID'
                  }"
                />
                <!-- {{ option.valid }} - {{ option.touched }} - {{ option.dirty }} -->

                <div
                  *ngIf="
                    !option?.valid &&
                    option?.touched &&
                    option?.dirty &&
                    option.status === 'INVALID'
                  "
                  class="invalid-feedback d-flex"
                >
                  {{ 'customProperties.optionError' | translate }}
                </div>
              </div>
              <img
                class="trash-icon"
                [ngClass]="{
                  'trash-adjust':
                    !option?.valid &&
                    option?.touched &&
                    option?.dirty &&
                    option.status === 'INVALID'
                }"
                src="assets/icons/gl_trash.svg"
                (click)="removeOption(i)"
              />
            </ng-container>
          </ng-container>
        </ng-container>
        <div
          class="defaultOption"
          *ngIf="
            form?.get('type')?.value == 'BOOLEAN' &&
            form?.get('isRequired').value == true
          "
        >
          <label class="name-label">
            {{ 'customProperties.defaultValue' | translate }}
          </label>
          <ng-select
            id="default"
            [items]="_defaultOptions"
            bindValue="default"
            formControlName="default"
            (change)="eventChangeSelect($event)"
            [clearable]="false"
            style="margin-bottom: 0 !important"
          >
          </ng-select>
        </div>
        <div class="mandatory-checkbox">
          <mat-checkbox formControlName="isRequired" (click)="changeCheckBox()">
            <p>{{ 'profile.error.required' | translate }}</p>
          </mat-checkbox>
          <div class="custom-tooltip bottom">
            <img
              class="info-icon"
              src="assets/icons/gl_information-outline.svg"
              style="margin-left: 8px"
            />
            <div class="tiptext" style="width: 164px; height: 56px">
              {{ 'customProperties.mandatoryTooltip' | translate }}
            </div>
          </div>
        </div>
        <button
          *ngIf="action === 'EDIT' && (resize$ | async)?.payload?.mobile"
          romaClickDelete
          class="action-btn-form"
          (wantDelete)="delete()"
          [disabled]="isLoading"
        >
          <img src="assets/icons/gl_trash_red.svg" />
          {{ 'general.deleteAlt' | translate }}
        </button>
      </form>
    </div>
  </div>
</roma-modal-template>
